import React, { useState } from 'react';
import { StandardsList } from '../StandardsList';

const Field = ({ label, name, value, onChange, placeholder, testId, textarea }) => (
  <div>
    <label className="block text-gray-700 font-medium mb-1 text-sm">{label}</label>
    {textarea ? (
      <textarea name={name} value={value} onChange={onChange} rows={2} placeholder={placeholder}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600" data-testid={testId} />
    ) : (
      <input name={name} value={value} onChange={onChange} placeholder={placeholder}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-600" data-testid={testId} />
    )}
  </div>
);

const Check = ({ name, checked, onChange, label, testId }) => (
  <label className="flex items-start gap-2 text-sm text-gray-700">
    <input type="checkbox" name={name} checked={checked} onChange={onChange} className="mt-1" data-testid={testId} />
    <span>{label}</span>
  </label>
);

export const SignupSafeguards = ({ formData, handleChange }) => {
  const [showStandards, setShowStandards] = useState(false);
  return (
    <div className="space-y-4 mt-6 pt-6 border-t border-gray-200" data-testid="signup-safeguards">
      <h3 className="font-bold text-gray-800">Licensing & Disclosures</h3>
      <div className="grid sm:grid-cols-2 gap-4">
        <Field label="Jurisdiction (state / country) *" name="jurisdiction" value={formData.jurisdiction} onChange={handleChange} placeholder="e.g., Georgia, USA" testId="jurisdiction-input" />
        <Field label="Business email" name="business_email" value={formData.business_email} onChange={handleChange} placeholder="office@yourfirm.com" testId="business-email-input" />
        <Field label="Licence number (if applicable)" name="license_number" value={formData.license_number} onChange={handleChange} placeholder="e.g., Bar #12345" testId="license-number-input" />
        <Field label="Licensing body" name="licensing_body" value={formData.licensing_body} onChange={handleChange} placeholder="e.g., State Bar of Georgia" testId="licensing-body-input" />
      </div>
      <div>
        <p className="font-medium text-gray-700 text-sm mb-2">Services you offer to families</p>
        <div className="space-y-2">
          <Check name="offers_free_education" checked={formData.offers_free_education} onChange={handleChange} testId="offers-free-education-checkbox" label="Free educational presentations (no selling)" />
          <Check name="offers_free_consultation" checked={formData.offers_free_consultation} onChange={handleChange} testId="offers-intro-consultation-checkbox" label="Free introductory consultation" />
          <Check name="offers_paid_services" checked={formData.offers_paid_services} onChange={handleChange} testId="offers-paid-services-checkbox" label="Paid services (contracted directly with you, not through LFF)" />
        </div>
      </div>
      <Field textarea label={`Fee disclosure${formData.offers_paid_services ? ' *' : ''}`} name="fee_disclosure" value={formData.fee_disclosure} onChange={handleChange} placeholder="e.g., Wills from $450 flat fee; hourly $200" testId="fee-disclosure-input" />
      <Field textarea label="Conflicts of interest *" name="conflicts_of_interest" value={formData.conflicts_of_interest} onChange={handleChange} placeholder="e.g., I earn commissions on insurance products I sell — or 'None'" testId="conflicts-input" />
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <button type="button" onClick={() => setShowStandards(s => !s)} className="text-blue-700 font-medium text-sm underline" data-testid="toggle-standards-btn">
          {showStandards ? 'Hide' : 'Read'} the Professional Participation Standards
        </button>
        {showStandards && <StandardsList className="mt-3" />}
        <div className="mt-3">
          <Check name="standards_accepted" checked={formData.standards_accepted} onChange={handleChange} testId="accept-standards-checkbox"
            label="I have read and agree to follow LFF's Professional Participation Standards. I understand my profile stays Pending Verification until an LFF administrator approves it." />
        </div>
      </div>
    </div>
  );
};
